import * as React from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom'
import Menu from './Menu';
import CampanaNotificaciones from './Landing/Notificaciones/CampanaNotificaciones';


export default class NavBar extends React.Component {

    sideBarTogglerClickedSmall = () => {
        $("body").trigger("resize");
        $("body").addClass("mini-sidebar");
        $('.navbar-brand span').hide();
    }

    navTogglerClickedSmall = () => {
        $("body").toggleClass("show-sidebar");
        $(".nav-toggler i").toggleClass("ti-menu");
        $(".nav-toggler i").addClass("ti-close");
    }

    sideBarTogglerClickedLarge = () => {
        let page = $("body").hasClass("mini-sidebar"); 
        if (page) {
            $("body").removeClass("mini-sidebar");
            $('.logo-mega').attr('src','/img/logo-marketplace-megatone.png');
        } else {
            $("body").addClass("mini-sidebar"); 
            $('.logo-mega').attr('src','/img/mini-logo-marketplace-megatone.png');
        };
    }


    render() {

        return (

            <header className="topbar background-rojo-megatone">
                <nav className="navbar top-navbar navbar-expand-sm navbar-light">

                    <div className="navbar-header mt-10 background-gris-megatone">
                        <Link className="navbar-brand" to="/">
                            <img 
                                className="logo-mega animated fadeInLeft" 
                                alt="logo" 
                                src="/img/logo-marketplace-megatone.png" 
                            /> 
                        </Link>
                    </div>

                    <div className="navbar-collapse justify-content-between row">

                        <div className="col-1">
                            <ul className="navbar-nav mr-auto d-lg-none">
                                <li className="nav-item">
                                    <a 
                                        onClick={this.navTogglerClickedSmall} 
                                        className="nav-link nav-toggler hidden-md-up waves-effect waves-dark" 
                                    >
                                        <i className="sl-icon-menu"/>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a 
                                        onClick={this.sideBarTogglerClickedSmall} 
                                        className="nav-link sidebartoggler hidden-sm-down waves-effect waves-dark"
                                    >
                                        <i className="sl-icon-menu ti-menu"/>
                                    </a>
                                </li>
                            </ul>
    
                            <ul className="navbar-nav mr-auto d-none d-lg-block">
                                <li className="nav-item"> 
                                    <a className="nav-link nav-toggler hidden-md-up waves-effect waves-dark" >
                                        <i className="sl-icon-menu"/>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a 
                                        onClick={this.sideBarTogglerClickedLarge} 
                                        className="nav-link sidebartoggler hidden-sm-down waves-effect waves-dark" 
                                    >
                                        <i className="sl-icon-menu ti-menu"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        
                        <div className='col-11'>
                            <div className="w-100 row justify-content-end">

                                <div className="col-auto d-inline-block">
                                    <CampanaNotificaciones/>
                                </div>
        
                                <div className="col-auto navbar-nav my-lg-0">
                                    <Menu history={this.props.history}/>
                                </div>

                            </div>
                        </div>

                    </div>
                </nav>
            </header>
        );
    }
}